/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Name_RequiredInputs */

const en_name_required = /** @type {(inputs: Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name *`)
};

const es_name_required = /** @type {(inputs: Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre *`)
};

/**
* | output |
* | --- |
* | "Name *" |
*
* @param {Name_RequiredInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const name_required = /** @type {((inputs?: Name_RequiredInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Name_RequiredInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_name_required(inputs)
	return es_name_required(inputs)
});